import React, { forwardRef, useRef, useImperativeHandle, useEffect } from 'react';
import classNames from 'classnames';
import { v4 } from 'uuid';
import styles from './ContextMenu.scss.js';
import useHotKeyScope from '../../Hooks/useHotKeyScope/useHotKeyScope.js';
import iconMapping from '../../../Icons/Icons/Icon/iconMapping.js';
import { contextMenuIconsMap } from './ContextMenu.shared.js';
import ContextMenuSeparator from '../Items/ContextMenuSeparator/ContextMenuSeparator.js';
import ContextMenuItem from '../Items/ContextMenuItem/ContextMenuItem.js';

/* eslint-disable react/no-array-index-key */
const preloadIcons = () => {
  Object.values(contextMenuIconsMap).forEach(iconPaths => {
    Object.values(iconPaths).forEach(iconPath => {
      new Image().src = iconMapping[iconPath].file;
    });
  });
};
const ContextMenu = /*#__PURE__*/forwardRef((_ref, outerRef) => {
  let {
    isOpen,
    handleClose,
    options,
    position,
    scopeRef = useRef(null)
  } = _ref;
  const innerRef = useRef(null);
  useImperativeHandle(outerRef, () => innerRef.current, []);
  const contextMenuScope = useRef(v4());
  useHotKeyScope(scopeRef, contextMenuScope.current);
  const handleOptionSelect = onClick => {
    onClick();
    handleClose();
  };
  useEffect(() => {
    setTimeout(() => {
      if (isOpen) {
        innerRef.current?.focus();
      }
    }, 100);
  }, [isOpen]);
  useEffect(() => {
    // We want to avoid not having rendered the icons of the options in the first render
    preloadIcons();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    role: "listbox",
    className: classNames(styles.container, {
      [styles['container--open']]: isOpen
    }),
    ref: innerRef,
    style: {
      left: `${position.x}px`,
      top: `${position.y}px`
    }
  }, options.map((option, index) => {
    if (option.type === 'separator') {
      return /*#__PURE__*/React.createElement(ContextMenuSeparator, {
        key: index
      });
    }
    return /*#__PURE__*/React.createElement(ContextMenuItem, {
      key: index,
      item: {
        ...option,
        onClick: () => handleOptionSelect(option.onClick)
      },
      keyScope: contextMenuScope.current
    });
  }));
});
var ContextMenu$1 = ContextMenu;

export { ContextMenu$1 as default };
//# sourceMappingURL=ContextMenu.js.map
